import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { IconCheck, IconSearch, IconFast, IconGear, IconCloud } from '../components/Icons';
import { SALES_EMAIL } from '../data/legal';
import './Services.css';

const Services: React.FC = () => {
  return (
    <div className="services mesh-gradient">
      <Hero
        title="Our Services"
        subtitle="From rapid prototyping to full-scale deployment, we deliver comprehensive AI-powered solutions that transform your ideas into thriving businesses."
      />

      <section className="service-offerings">
        <div className="offerings-content">
          <div className="service-grid">
            <Card
              variant="service"
              image="/images/rapid_dev_modern.webp"
              imageAlt="Rapid Development"
              title="Rapid Development"
              description="From concept to deployment in record time using modern frameworks and AI-assisted development."
            >
              <ul className="service-features">
                <li><IconCheck /> MVP development in 1-2 weeks</li>
                <li><IconCheck /> AI-assisted code generation</li>
                <li><IconCheck /> Modern React/Node.js stack</li>
                <li><IconCheck /> Cloud-native architecture</li>
              </ul>
            </Card>

            <Card
              variant="service"
              image="/images/ai_solutions_modern.webp"
              imageAlt="AI-Powered Solutions"
              title="AI-Powered Solutions"
              description="Leverage cutting-edge AI technologies to create intelligent, responsive applications."
            >
              <ul className="service-features">
                <li><IconCheck /> Natural language processing</li>
                <li><IconCheck /> Machine learning integration</li>
                <li><IconCheck /> Intelligent automation</li>
                <li><IconCheck /> Predictive analytics</li>
              </ul>
            </Card>

            <Card
              variant="service"
              image="/images/fullstack_modern.webp"
              imageAlt="Full-Stack Expertise"
              title="Full-Stack Expertise"
              description="End-to-end development covering web, mobile, and cloud infrastructure."
            >
              <ul className="service-features">
                <li><IconCheck /> React & TypeScript frontend</li>
                <li><IconCheck /> Serverless backend (AWS)</li>
                <li><IconCheck /> Mobile app development</li>
                <li><IconCheck /> DevOps & deployment</li>
              </ul>
            </Card>
          </div>
        </div>
      </section>

      <section className="process">
        <div className="process-content">
          <h2>Our Process</h2>
          <div className="process-steps">
            <Card
              variant="process"
              icon={<IconSearch />}
              title="Discovery & Planning"
              description="We work closely with you to understand your vision, target market, and technical requirements."
            />
            <Card
              variant="process"
              icon={<IconFast />}
              title="Rapid Prototyping"
              description="Quick iteration on core features and user experience using AI-assisted development tools."
            />
            <Card
              variant="process"
              icon={<IconGear />}
              title="Development & Testing"
              description="Full-scale development with continuous testing, security reviews, and performance optimization."
            />
            <Card
              variant="process"
              icon={<IconCloud />}
              title="Deployment & Support"
              description="Production deployment with monitoring, maintenance, and ongoing feature development."
            />
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content glass">
          <h2>Ready to Get Started?</h2>
          <p>Let's transform your idea into a successful business together.</p>
          <div className="cta-buttons">
            <a href={`mailto:${SALES_EMAIL}`} className="cta-primary glass">Contact Us</a>
            <Link to="/projects" className="cta-secondary glass">View Our Work</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;